import styled from "styled-components";

export const SECONDPARTSC = styled.img`
  width: 1150.55;
  height: 596.73;
`;

export const SECONDPAGE_HOME_H1 = styled.h1`
  font-size: 40px;
  color: #3d4853;
  font-weight: lighter;
`;

export const SECONDPAGE_HOME_H2 = styled.p`
  font-size: 20.8px;
  color: #5a6b7b;
`;

export const SECONDPAGE_HOME_BUTTON1 = styled.button`
  width: 23%;
  padding: 1%;
  background-color: #0288d1;
  font-size: 16px;
  color: white;
  border-radius: 5px;
  border-color: #03a9f4;
  &:hover {
    background-color: #0277bd;
  }
`;

export const Signbutt2 = styled.button`
  height: 6%;
  width: 19%;
  margin-top: 30px;
  padding: 8px;
  margin-left: 3%;
  border-color: #03a9f4;
  border: 1px solid #03a9f4;
  background-color: #f8fdff;

  color: #03a9f4;
  &:hover {
    background-color: #03a9f4;
    color: white;
    .Plinthird {
      color: white;
    }
  }
`;
export const DarkmodeButton = styled.button`
border-color: #03a9f4;
border: 1px solid #03a9f4;
background-color: #f8fdff;
width: 7%;
height: 30px;
color: #03a9f4;
&:hover {
  background-color: #03a9f4;
  color: white;
  .Plinthird {
    color: white;
  }

`;

// Fifthpage cssssss ******

export const FIFTH_HOME_H3ONE = styled.h3`
  font-size: 16px;
  color: #3d4853;
  margin-right: 350px;
`;

export const FIFTH_HOME_H4ONE = styled.h4`
  font-size: 18px;
  color: #5a6b7b;
  margin-right: 350px;
`;

export const FIFTH_HOME_AINH4 = styled.a`
  font-size: 18px;
  color: #03a9f4;
`;
export const Switchb = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
`;
export const SEVENTHPART1_DATA = styled.div`
  float: left;
  border: 2px solid whitesmoke;
  width: 260px;
  height: 162px;
  padding: 3px;
  margin-left: 15px;
  background-color: #ffffff;
  text-align: left;
  &:hover {
    transform: scale(1.1);
  }
`;
